var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSessionExpired(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "70px",
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / status pop up / session expired") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-status-pop-up-/-session-expired",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3535354,63.6363636 C19.7324987,63.6363636 7.07070707,50.9743286 7.07070707,35.3535354 C7.07070707,19.7324987 19.7324987,7.07070707 35.3535354,7.07070707 C50.9743286,7.07070707 63.6363636,19.7327421 63.6363636,35.3535354 C63.6363636,50.9743286 50.9743286,63.6363636 35.3535354,63.6363636 M35.0001224,0 C15.6712218,0 0,15.6712218 0,35.0001224 C0,54.3312253 15.6712218,70 35.0001224,70 C54.3312253,70 70,54.3334277 70,35.0001224 C70,15.6712218 54.3309806,0 35.0001224,0",
    id: "Fill-1-Copy",
    fill: "#C42323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1655882,35.1158824 C51.1867647,35.1158824 51.9979412,35.9517647 51.9979412,36.975 C51.9979412,37.9961765 51.1867647,38.8320588 50.1655882,38.8320588 L32.8344118,38.8320588 C32.1508824,38.8320588 31.5558824,38.4367647 31.2408824,37.8911765 L31.21,37.8664706 L31.1852941,37.8108824 L31.1852941,37.7861765 L31.1605882,37.7305882 L31.1297059,37.6811765 L31.1297059,37.6502941 L31.105,37.6008824 L31.0802941,37.5782353 L31.0802941,37.5205882 L31.0576471,37.4732353 L31.0576471,37.4402941 L31.0247059,37.3929412 L31.0247059,37.2879412 L31,37.255 L31,14.8344118 C31,13.8132353 31.8132353,13 32.8344118,13 C33.8473529,13 34.6832353,13.8132353 34.6832353,14.8344118 L34.6832353,35.1158824 L50.1655882,35.1158824 Z",
    id: "Path-Copy",
    stroke: "#C42323",
    strokeWidth: 3,
    fill: "#C42323"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionExpired);
export default __webpack_public_path__ + "static/media/session-expired.e986de08.svg";
export { ForwardRef as ReactComponent };